import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";
import { getloanAdvanceData } from "../../../../store/Api";
import { useEffect } from "react";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useState } from "react";
import EmployeeDetails from "./employeeDetails";
import React from "react";
import nodeinstance from "../../../../nodeInstance";
import EmployeeManager from "./employeemanager";
import { useLocation } from "react-router-dom";
import { setBreadCrumb } from "../../../../store/userSlice";

export default function Employeeloanadvance() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const [refreshData, setRefreshData] = useState(false);
  const titles = [
    "S.NO",
    "FLIGHT DETAILS",
    "COUNTRY",
    "PAX",
    "DATE OF ARRIVAL",
    "TIME OF ARRIVAL",
    "ARRIVAL SECTOR",
    "PICKUP TO BE ARRANGED",
    "PROJECT INCHARGE",
    "AMOUNT REQUEST",
    "FUNDS",
  ];
  useEffect(() => {
    dispatch(getloanAdvanceData(token));
  }, []);

  const loanAdvance = useSelector((state) => state.loanAdvanceData);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList: originalCurrentList,
  } = useSearchPagination(loanAdvance?.data);
  const currentList = [...originalCurrentList].sort((a, b) => {
    const dateA = new Date(a.created_at || a.updated_at);
    const dateB = new Date(b.created_at || b.updated_at);
    return dateB - dateA;
  });

  const [flightId, setFlightId] = useState();
  const [employee, setEmployee] = useState();
  const [propData, setPropData] = useState();

  const arrivalData = async () => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/loanAdvance/getEmpById/${flightId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("eftyfetyfteftdyfyfe", response);
      if (response.status === 200) {
        setEmployee(response.data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  useEffect(() => {
    if (flightId === undefined) {
      return;
    } else {
      arrivalData();
    }
  }, [flightId, refreshData]);
  const handleRowClick = (id, data) => {
    setFlightId(id);
    setPropData(data);
  };
  const [searchWords, setSearchWords] = useState([]);
  console.log("Data to be seen here....fgfh....", employee);
  const [loanAmount, setLoanAmount] = useState();

  const location = useLocation();
  useEffect(() => {
    dispatch(
      setBreadCrumb([
        {
          label: "LOAN AND ADVANCE",
          link: "",
        },
      ])
    );
  }, [location]);

  return (
    <>
      <div className="pt-2 uppercase m-3">
        {/* <div className="flex flex-wrap  gap-2 w-full items-center "> */}
        <div className="flex flex-wrap gap-2 mb-1 items-center">
          <h3 className="ml-4">ARRIVAL BATCHES : </h3>

          <Search
            keywords={[
              "project_incharge",
              "flight_details",
              "country",
              "arrival_sector",
              "pickup_to_be_arranged",
            ]}
            setSearchWords={setSearchWords}
            className="ml-auto text-lg p-3"
          />

          <div
            // className={`grid grid-cols-table-quotation auto-cols-min gap-5 p-8 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md`}
            className={`grid grid-cols-10 gap-4 p-9 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline rounded-md`}
            style={currentList.length > 5 ? { height: "350px" } : {}}
          >
            {titles.map((title, index) => (
              <p key={index} className="font-semibold uppercase">
                {title}
              </p>
            ))}

            {currentList?.map((listItem, index) => (
              <React.Fragment key={index}>
                <PaginationIndex index={index} />

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem?.flight_details}
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    className={flightId === listItem?.id ? "bg-lightred" : ""}
                    style={{ cursor: "pointer" }}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.country}
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={String(
                      listItem.employee_count === null
                        ? "----"
                        : listItem.employee_count
                    )}
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </p>

                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      listItem.date_of_arrival
                        ? new Date(listItem.date_of_arrival)
                            .toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            })
                            .split(" ")
                            .join("-")
                            .toUpperCase()
                        : "-----"
                    }
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.time_of_arrival}
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.arrival_sector}
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.pickup_to_be_arranged}
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={listItem.project_incharge}
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </p>
                <p style={{ textAlign: "center" }}>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={Number(listItem?.amount_requested ?? 0)
                      .toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                      .replace(/,/g, "")}
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </p>
                <p>
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={
                      parseInt(listItem?.amount_requested) ===
                      parseInt(listItem?.cleared_amount)
                        ? "IMPRESSED CLEARED"
                        : parseInt(listItem?.amount_requested) <
                            parseInt(listItem?.cleared_amount)
                          ? "ISSUED"
                          : "TO BE ISSUED"
                    }
                    onClick={() => {
                      handleRowClick(listItem?.id, listItem);
                    }}
                    style={{ cursor: "pointer" }}
                  />
                </p>

                <hr className="border-[1.5px] border-slate-100  w-full col-span-11" />
              </React.Fragment>
            ))}
          </div>
        </div>
        <Pagination />
      </div>
      {employee?.length > 0 ? (
        <>
          <div>
            <EmployeeDetails
              EmployeeData={employee}
              data={propData}
              setRefreshData={setRefreshData}
              refreshData={refreshData}
              flightId={flightId}
            />
          </div>
        </>
      ) : (
        ""
      )}
      <div>
        <EmployeeManager propData={propData} EmployeeData={employee} />
      </div>
    </>
  );
}
